<div class="row">
  <div class="col-sm-12">
    <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Title' | translate}}</h2>
  </div>
</div>

<div class="row">
  <!--Relação com o falecido-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="deceasedRelationship" [class.disabled]="isNotStateRLDiferido()">
       <span class="mandatory">*</span>
       {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.DeceasedRelationship' | translate}}
      </label>
      <select class="custom-select"
              [(ngModel)]="cardData.deceasedRelationship"
              name="deceasedRelationship"
              #deceasedRelationship="ngModel"
              (change)="scholarSituationDeathDateRequired();"
              required
              [disabled]=" isNotStateRLDiferido()"
              nullableSelect
              [clearRelated]="{model : this.cardData , propsToReset : ['professionalSituation','startDateProfession','registrationYear','educationLevelDeathDate','scholarSituationDeathDate','otherDeceasedRelationship', 'startDateCohabitation', 'marriageDate', 'hasCourtAlimony', 'alimonyValueDeathDate','monthlyncome', 'income','hasIRSExemption', 'hasChargeDeceased','activeProfessionalSituation']} ">
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of dropListDeceasedRelationship" [value]="domain.value">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="deceasedRelationship"></validation-message>
    </div>
  </div>

  <!--Outra relação com o falecido-->
  <!--Activo: Sim, se Relação com o falecido = Outros e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="otherDeceasedRelationship"
             [class.disabled]=" cardData.deceasedRelationship !== deceasedRelationshipValues.Outros || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(cardData.deceasedRelationship !== deceasedRelationshipValues.Outros || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.OtherDeceasedRelationship' | translate}}
      </label>
      <input class="form-control"
             type="text"
             [(ngModel)]="cardData.otherDeceasedRelationship"
             name="otherDeceasedRelationship"
             #otherDeceasedRelationship="ngModel"
             maxlength="60"
             style='text-transform:uppercase'
             (change)="capitalize('otherDeceasedRelationship')"
             [disabled]="cardData.deceasedRelationship !== deceasedRelationshipValues.Outros || isNotStateRLDiferido()"
             [required]="!(cardData.deceasedRelationship !== deceasedRelationshipValues.Outros || isNotStateRLDiferido())">
      <validation-message [control]="otherDeceasedRelationship"></validation-message>
    </div>
  </div>

  <!--Data de inicio de vivência em união de facto-->
  <!--Activo:Sim, se Benefício requerido = SO ou SM e Relação com falecido = união de facto e, se remetente = RL, o habilitando estiver no estado “Deferido-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="startDateCohabitation"
             [class.disabled]=" cardData.deceasedRelationship !== deceasedRelationshipValues.UniaoDeFacto || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido() ">
        <span class="mandatory" *ngIf="!(cardData.deceasedRelationship !== deceasedRelationshipValues.UniaoDeFacto || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.StartDateCohabitation' | translate}}
      </label>
      <div class="form-row">
        <div class="input-group col-sm-12">
          <input #dpDateOfBirth="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.startDateCohabitation" name="startDateCohabitation"
                 maxlength="10" readonly
                 [minDate]="minDate"
                 [maxDate]="maxDate"
                 #startDateCohabitation="ngModel"
                 [disabled]="cardData.deceasedRelationship !== deceasedRelationshipValues.UniaoDeFacto || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()"
                 [required]="!(cardData.deceasedRelationship !== deceasedRelationshipValues.UniaoDeFacto || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpDateOfBirth)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="startDateCohabitation"></validation-message>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">

  <!--Data do Casamento-->
  <!--Activo:Sim, se Benefício requerido = SO ou SM e Relação com falecido = Cônjuge e, se remetente = RL, o habilitando estiver no estado “Deferido-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="marriageDate"
             [class.disabled]=" cardData.deceasedRelationship !== deceasedRelationshipValues.Conjugue || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(cardData.deceasedRelationship !== deceasedRelationshipValues.Conjugue || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.MarriageDate' | translate}}
      </label>
      <div class="form-row">
        <div class="input-group col-sm-12">
          <input #dpMarriageDate="bsDatepicker" bsDatepicker type="text" autocomplete="off"
                 class="form-control DatepickerCustomClasse"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.marriageDate" name="marriageDate"
                 maxlength="10" readonly
                 #marriageDate="ngModel"
                 [minDate]="minDate"
                 [maxDate]="maxDate"
                 [disabled]="cardData.deceasedRelationship !== deceasedRelationshipValues.Conjugue || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()"
                 [required]="!(cardData.deceasedRelationship !== deceasedRelationshipValues.Conjugue || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpMarriageDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpMarriageDate.isDisabled && dpMarriageDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="marriageDate"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <!--Recebe pensão-->
  <!--Activo: Sim, se Benefício requerido = SO e Relação com falecido = Ex-cônjuge e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="cardData.deceasedRelationship !== deceasedRelationshipValues.ExConjugue || benefitType.survivalPensionBenefit?.toString() != 'true' || isNotStateRLDiferido()">
        <label for="hasCourtAlimony"
               [class.disabled]="cardData.deceasedRelationship !== deceasedRelationshipValues.ExConjugue || benefitType.survivalPensionBenefit?.toString() != 'true' || isNotStateRLDiferido()">
          <span class="mandatory"
                *ngIf="!(cardData.deceasedRelationship !== deceasedRelationshipValues.ExConjugue || benefitType.survivalPensionBenefit?.toString() != 'true' || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.HasCourtAlimony' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()"
                 class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasCourtAlimony?.toString()"
                 [radioLabel]="hasCourtAlimony">
            <input type="radio"
                   [(ngModel)]="cardData.hasCourtAlimony"
                   name="hasCourtAlimony"
                   #hasCourtAlimony="ngModel"
                   [value]="domain.value"
                   [required]="!(cardData.deceasedRelationship !== deceasedRelationshipValues.ExConjugue || benefitType.survivalPensionBenefit?.toString() != 'true' || isNotStateRLDiferido())"
                   [clearRelated]="{model : this.cardData , propsToReset : ['alimonyValueDeathDate']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>

      </fieldset>
    </div>

  </div>

  <!--Valor da pensão-->
  <!--Activo: Sim, se Recebe pensão de alimentos homologada judicialmente = Sim e, se remetente = RL, o habilitando estiver no estado “Deferido-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="alimonyValueDeathDate"
             [class.disabled]=" cardData.hasCourtAlimony?.toString() !== 'true'  || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(cardData.hasCourtAlimony?.toString() !== 'true'  || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.AlimonyValueDeathDate' | translate}}
      </label>
      <div class="btn-group btn-group-toggle">
        <input class="form-control input-left"
               type="text"
               currency
               placeholder="{{'Placeholders.Generic.Currency' | translate}}"
               [(ngModel)]="cardData.alimonyValueDeathDate"
               name="alimonyValueDeathDate"
               #alimonyValueDeathDate="ngModel"
               maxValue="999000"
               minValue="0"
               messageFieldType="currency"
               [disabled]="cardData.hasCourtAlimony?.toString() !== 'true'  || isNotStateRLDiferido()"
               [required]="!(cardData.hasCourtAlimony?.toString() !== 'true'  || isNotStateRLDiferido())">
        <span class="input-icon-span-left">€</span>
        <validation-message [control]="alimonyValueDeathDate"></validation-message>
      </div>
    </div>
  </div>

</div>


<div class="row">

  <!--Encontra-se a cargo do falecido?-->
  <!--Activo: Sim, se Benefício requerido = SO ou SM e Relação com falecido = Enteados ou Netos e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="!isFilhoOuEnteado() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido() ">
        <label for="hasChargeDeceased"
               [class.disabled]="!isFilhoOuEnteado() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(!isFilhoOuEnteado() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.HasChargeDeceased' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasChargeDeceased?.toString()"
                 [radioLabel]="hasChargeDeceased">
            <input type="radio"
                   [(ngModel)]="cardData.hasChargeDeceased"
                   name="hasChargeDeceased"
                   [clearRelated]="{model : this.cardData , propsToReset : ['professionalSituation','scholarSituationDeathDate','activeProfessionalSituation','educationLevelDeathDate','registrationYear','startDateProfession','income']} "
                   (change)="activeProfessionalSituationRequired"
                   #hasChargeDeceased="ngModel"
                   [value]="domain.value"
                   [required]="!(!isFilhoOuEnteado() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--Rendimento mensal-->
  <!--Activo: Sim, se Benefício requerido = SO ou SM e Relação com falecido = Pais ou Avós e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="monthlyncome"
             [class.disabled]="!isPaisOuAvos()  || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(!isPaisOuAvos()  || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.MonthlyIncome' | translate}}
      </label>
      <div class="btn-group btn-group-toggle">
        <input class="form-control input-left"
               type="text"
               currency
               placeholder="{{'Placeholders.Generic.Currency' | translate}}"
               [(ngModel)]="cardData.monthlyncome"
               name="monthlyncome"
               #monthlyncome="ngModel"
               maxValue="999000"
               minValue="0"
               messageFieldType="currency"
               [disabled]="!isPaisOuAvos()  || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()"
               [required]="!(!isPaisOuAvos()  || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">
        <span class="input-icon-span-left">€</span>
        <validation-message [control]="monthlyncome"></validation-message>
      </div>
    </div>
  </div>

  <!--Encontra-se isento de apresentação de IRS?-->
  <!--Activo: Sim, se Benefício requerido = SO ou SM e Relação com falecido = Pais ou Avós e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="!isPaisOuAvos() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
        <label for="hasIRSExemption"
               [class.disabled]="!isPaisOuAvos() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(!isPaisOuAvos() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.HasIRSExemption' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasIRSExemption?.toString()"
                 [radioLabel]="hasIRSExemption">
            <input type="radio"
                   [(ngModel)]="cardData.hasIRSExemption"
                   name="hasIRSExemption"
                   #hasIRSExemption="ngModel"
                   [value]="domain.value"
                   [required]="!(!isPaisOuAvos() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

</div>

<div class="row">

  <!--Situação escolar à data do óbito-->
  <!--Activo: Sim, se Benefício requerido = SO ou SM e Relação com falecido:
  - Filhos + Maior de idade
  ou
  - Enteados ou Netos e Encontra-se a cargo do falecido = Sim
  Sim, se
  e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="scholarSituationDeathDate"
             [class.disabled]="!scholarSituationDeathDateRequired() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido() ">
        <span class="mandatory"
              *ngIf="!(!scholarSituationDeathDateRequired() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.ScholarSituationDeathDate' | translate}}
      </label>
      <select class="custom-select"
              [(ngModel)]="cardData.scholarSituationDeathDate"
              name="scholarSituationDeathDate"
              #scholarSituationDeathDate="ngModel"
              required
              [dropdownTitle]="{value : cardData.scholarSituationDeathDate, dimensions :  scholarSituation }"
              nullableSelect
              [disabled]="!scholarSituationDeathDateRequired() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()"
              [required]="!(!scholarSituationDeathDateRequired() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())"
              [clearRelated]="{model : this.cardData , propsToReset : ['educationLevelDeathDate', 'registrationYear']} ">
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of dropListScholarSituationDeathDate" [value]="domain.value">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="scholarSituationDeathDate"></validation-message>
    </div>
  </div>

  <!--Grau de ensino à data do óbito-->
  <!--Activo: Sim, se Situação escolar à data do óbito <> Não colocado e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="educationLevelDeathDate" [class.disabled]="!isDiferentDeColocado() || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(!isDiferentDeColocado() || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.EducationLevelDeathDate' | translate}}
      </label>
      <select class="custom-select"
              [(ngModel)]="cardData.educationLevelDeathDate"
              name="educationLevelDeathDate"
              #educationLevelDeathDate="ngModel"
              [dropdownTitle]="{value : cardData.educationLevelDeathDate, dimensions :  educationLevel }"
              nullableSelect
              [disabled]="!isDiferentDeColocado() || isNotStateRLDiferido()"
              [required]="!(!isDiferentDeColocado() || isNotStateRLDiferido())">
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of dropdownEducationLevelTOD" [value]="domain.value">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="educationLevelDeathDate"></validation-message>
    </div>
  </div>

  <!--Ano de matricula-->
  <!--Activo: Sim, se Situação escolar à data do óbito <> Não colocado e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="registrationYear" [class.disabled]="!isDiferentDeColocado() || isNotStateRLDiferido()">
        <span class="mandatory" *ngIf="!(!isDiferentDeColocado() || isNotStateRLDiferido())">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.RegistrationYear' | translate}}
      </label>
      <input class="form-control"
             type="text"
             [(ngModel)]="cardData.registrationYear"
             name="registrationYear"
             #registrationYear="ngModel"
             maxValue="{{anoAtual}}"
             maxlength="4"
             pattern="\d*"
             [disabled]="!isDiferentDeColocado() || isNotStateRLDiferido()"
             [required]="!(!isDiferentDeColocado() || isNotStateRLDiferido())">
      <validation-message [control]="registrationYear"></validation-message>
    </div>
  </div>


</div>

<div class="row">

  <!--Situação profissional ativa?-->
  <!--Activo: Sim, se Benefício requerido = SO ou SM e Relação com falecido:
  - Filhos + Maior de idade
  ou
  - Enteados ou Netos e Encontra-se a cargo do falecido = Sim
  e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="!scholarSituationDeathDateRequired() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
        <label for="activeProfessionalSituation"
               [class.disabled]="!scholarSituationDeathDateRequired() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(!scholarSituationDeathDateRequired() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.ActiveProfessionalSituation' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.activeProfessionalSituation?.toString()"
                 [radioLabel]="activeProfessionalSituation">
            <input type="radio"
                   [(ngModel)]="cardData.activeProfessionalSituation"
                   name="activeProfessionalSituation"
                   #activeProfessionalSituation="ngModel"
                   [value]="domain.value"
                   [required]="!(!scholarSituationDeathDateRequired() || isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())"
                   [clearRelated]="{model : this.cardData , propsToReset : ['startDateProfession', 'income', 'professionalSituation']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--Data de início de atividade profissional-->
  <!--Activo: Sim, se Situação profissional ativa = Sim e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="startDateProfession"
             [class.disabled]="cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido()">
        <span *ngIf="!(cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido())" class="mandatory">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.StartDateProfession' | translate}}
      </label>
      <div class="form-row">
        <div class="input-group col-sm-12">
          <input #dpStartDateProfession="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.startDateProfession"
                 name="startDateProfession"
                 maxlength="10"
                 [minDate]="minDate"
                 [maxDate]="maxDate"
                 #startDateProfession="ngModel"
                 [required]="!(cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido())"
                 [disabled]="cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido()"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpStartDateProfession)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpStartDateProfession.isDisabled && dpStartDateProfession.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="startDateProfession"></validation-message>
        </div>
      </div>
    </div>
  </div>

  <!--Valor que aufere-->
  <!--Activo: Sim, se Situação profissional ativa = Sim e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="income" [class.disabled]="cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido()">
        <span *ngIf="!(cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido())" class="mandatory">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.Income' | translate}}
      </label>
      <div class="btn-group btn-group-toggle">
        <input class="form-control input-left"
               type="text"
               currency
               placeholder="{{'Placeholders.Generic.Currency' | translate}}"
               [(ngModel)]="cardData.income"
               name="income"
               #income="ngModel"
               maxValue="999000"
               minValue="0"
               messageFieldType="currency"
               [required]="!(cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido())"
               [disabled]="cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido()">
        <span class="input-icon-span-left">€</span>
        <validation-message [control]="income"></validation-message>
      </div>
    </div>
  </div>


</div>

<div class="row">

  <!--Detalhe Situação profissional-->
  <!--Activo: Sim, se Situação profissional ativa = Sim e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-8">
    <div class="form-group">
      <label for="professionalSituation" [class.disabled]="cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido()">
        <span *ngIf="!(cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido())" class="mandatory">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.ProfessionalSituation' | translate}}
      </label>
      <input class="form-control"
             type="text"
             [(ngModel)]="cardData.professionalSituation"
             name="professionalSituation"
             #professionalSituation="ngModel"
             maxlength="60"
             [required]="!(cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido())"
             [disabled]="cardData.activeProfessionalSituation?.toString() != 'true' || isNotStateRLDiferido()">
      <validation-message [control]="professionalSituation"></validation-message>
    </div>
  </div>


</div>

<div class="row">

  <!--Sofre de incapacidade permanente e total para o trabalho?-->
  <!--Activo: Sim, se Benefício requerido = SO ou SM e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
        <label for="hasIncapacity" [class.disabled]="isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.HasIncapacity' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0"
                 class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasIncapacity?.toString()"
                 [radioLabel]="hasIncapacity">
            <input type="radio"
                   [(ngModel)]="cardData.hasIncapacity"
                   name="hasIncapacity"
                   #hasIncapacity="ngModel"
                   [value]="domain.value"
                   [disabled]="isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()"
                   [required]="!(isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())"
                   [clearRelated]="{model : this.cardData , propsToReset : ['hasSocialPension', 'socialPensionDate']} ">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--É beneficiário da pensão social para a inclusão ou de prestações familiares?-->
  <!--Activo: Sim, se Sofre de incapacidade permanente e total para o trabalho = Sim e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset [disabled]="cardData.hasIncapacity?.toString() != 'true'  || isNotStateRLDiferido()">
        <label for="hasSocialPension" [class.disabled]="cardData.hasIncapacity?.toString() != 'true'  || isNotStateRLDiferido()">
          <span *ngIf="!(cardData.hasIncapacity?.toString() != 'true'  || isNotStateRLDiferido())" class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.HasSocialPension' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasSocialPension?.toString()"
                 [radioLabel]="hasSocialPension">
            <input type="radio"
                   [(ngModel)]="cardData.hasSocialPension"
                   name="hasSocialPension"
                   #hasSocialPension="ngModel"
                   [value]="domain.value"
                   [required]="!(cardData.hasIncapacity?.toString() != 'true'  || isNotStateRLDiferido())"
                   [disabled]="cardData.hasIncapacity?.toString() != 'true'  || isNotStateRLDiferido()"
                   [clearRelated]="{model : this.cardData , propsToReset : ['socialPensionDate']}">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

  <!--Data do início da pensão social para a inclusão-->
  <!--Activo: Sim, se É beneficiário da pensão social para a inclusão = Sim e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <label for="socialPensionDate" [class.disabled]="cardData.hasSocialPension?.toString() != 'true' || isNotStateRLDiferido()">
        <span *ngIf="!(cardData.hasSocialPension?.toString() != 'true' || isNotStateRLDiferido())" class="mandatory">*</span>
        {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.SocialPensionDate' | translate}}
      </label>
      <div class="form-row">
        <div class="input-group col-sm-12">
          <input #dpSocialPensionDate="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                 placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.socialPensionDate"
                 name="socialPensionDate"
                 maxlength="10"
                 [minDate]="minDate"
                 [maxDate]="maxDate"
                 #socialPensionDate="ngModel"
                 [required]="!(cardData.hasSocialPension?.toString() != 'true' || isNotStateRLDiferido())"
                 [disabled]="cardData.hasSocialPension?.toString() != 'true' || isNotStateRLDiferido()"
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpSocialPensionDate)" />
          <div class="input-group-append disable-on-fieldset" (click)="!dpSocialPensionDate.isDisabled && dpSocialPensionDate.toggle()">
            <span class="input-group-text" id="basic-addon2">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="socialPensionDate"></validation-message>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="row">
  <!--Existe interdição judicial?-->
  <!--Activo: Sim, se Benefício requerido = SO ou SM e, se remetente = RL, o habilitando estiver no estado “Deferido”-->
  <div class="col-sm-4">
    <div class="form-group">
      <fieldset  [disabled]="isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
        <label for="hasJudicialInterdiction" [class.disabled]="isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()">
          <span class="mandatory" *ngIf="!(isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.DeceasedRelationship.Fields.HasJudicialInterdiction' | translate}}
        </label>
        <div class="btn-group btn-group-toggle maxWidth">
          <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0"
                 class="btn btn-toogle"
                 [class.active]="domain.value==cardData.hasJudicialInterdiction?.toString()"
                 [radioLabel]="hasJudicialInterdiction">
            <input type="radio"
                   [(ngModel)]="cardData.hasJudicialInterdiction"
                   name="hasJudicialInterdiction"
                   #hasJudicialInterdiction="ngModel" [value]="domain.value"
                   [disabled]="isNotSurvivalPensionOrSM()  || isNotStateRLDiferido()"
                   [required]="!(isNotSurvivalPensionOrSM()  || isNotStateRLDiferido())">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>
  </div>

</div>
